import { Reducer } from 'redux';

import { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import { Msal } from './types';

export type SessionAction = SessionConfigureAction;

const initialState: Msal = {
  instance: '',
  tenant: '',
  clientId: '',
  redirectUri: '',
  resources: {
    yammer: '',
    graph: '',
    loki: '',
    substrateNotifications: '',
    substratePushSubscription: '',
    ocps: '',
  },
  validAuthRedirectUris: [],
};

const reducer: Reducer<Msal, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.msal;
    default:
      return state;
  }
};

export default reducer;
